<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <v-btn-toggle
        :value="data.type"
        @change="setKey('type', $event)"
        color="primary"
        class="w-full"
        mandatory
      >
        <v-btn
          v-for="item in modalTypes"
          :key="item.id"
          :value="item.id"
          class="flex-1"
          small
          :disabled="readonly"
        >
          {{ item.name }}
        </v-btn>
      </v-btn-toggle>

      <v-card
        v-if="data.type.includes('rental')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Aluguel</b>
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field
              :value="data.equipment_name"
              @input="setKey('equipment_name', $event)"
              label="Nome do Equipamento"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Nome do Equipamento é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              :value="data.equipment_quantity"
              @input="setKey('equipment_quantity', $event, parseFloat)"
              label="Quantidade"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Quantidade é obrigatório']"
              :disabled="readonly"
              type="number"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              :value="data.equipment_description"
              @input="setKey('equipment_description', $event)"
              label="Descrição do Equipamento"
              outlined
              dense
              rows="2"
              hide-details
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.rental_days"
              @input="setKey('rental_days', $event, parseFloat)"
              label="Dias de Locação"
              outlined
              dense
              hide-details
              type="number"
              :rules="[(v) => !!v || 'Dias de Locação é obrigatório']"
              :disabled="readonly"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              :value="data.rental_price"
              @input="setKey('rental_price', $event, parseFloat)"
              label="Preço do Aluguel"
              placeholder="Preço por dia/equipamento"
              prefix="R$"
              outlined
              dense
              hide-details
              type="number"
              :rules="[(v) => !!v || 'Duração do Aluguel é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
        </v-row>
      </v-card>
      <v-card
        v-if="data.type.includes('sell')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Venda</b>
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field
              :value="data.equipment_name"
              @input="setKey('equipment_name', $event)"
              label="Nome do Equipamento"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Nome do Equipamento é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              :value="data.equipment_quantity"
              @input="setKey('equipment_quantity', $event, parseFloat)"
              label="Quantidade"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Quantidade é obrigatório']"
              :disabled="readonly"
              type="number"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              :value="data.equipment_description"
              @input="setKey('equipment_description', $event)"
              label="Descrição do Equipamento"
              outlined
              dense
              rows="2"
              hide-details
              :disabled="readonly"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              :value="data.sell_price"
              @input="setKey('sell_price', $event, parseFloat)"
              label="Preço de Venda"
              placeholder="Preço por equipamento"
              prefix="R$"
              outlined
              dense
              hide-details
              type="number"
              :rules="[(v) => !!v || 'Duração do Aluguel é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
        </v-row>
      </v-card>
      <v-card
        v-if="data.type.includes('loan')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Emprestimo</b>
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field

              :value="data.equipment_name"
              @input="setKey('equipment_name', $event)"
              label="Nome do Equipamento"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Nome do Equipamento é obrigatório']"
              :disabled="readonly"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              :value="data.equipment_quantity"
              @input="setKey('equipment_quantity', $event, parseFloat)"
              label="Quantidade"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Quantidade é obrigatório']"
              :disabled="readonly"
              type="number"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              :value="data.equipment_description"
              @input="setKey('equipment_description', $event)"
              label="Descrição do Equipamento"
              outlined
              dense
              rows="2"
              hide-details
              :disabled="readonly"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-text-field
        :value="data.other_price"
        @input="setKey('other_price', $event, parseFloat)"
        label="Outros custos"
        hint="Apenas relacionados ao envio"
        prefix="R$"
        class="mt-4"
        outlined
        dense
        :disabled="readonly"
      />
      <v-textarea
        v-if="data.other_price && data.other_price > 0"
        :value="data.other_description"
        @input="setKey('other_description', $event)"
        label="Descrição dos outros custos"
        hide-details
        rows="2"
        outlined
        dense
        :rules="[(v) => !!v || 'Descrição dos outros custos é obrigatório']"
        :disabled="readonly"
      />
    </v-form>
  </div>
</template>

<script>
const defaultData = () => {
  return {
    type: "rental",
    equipment_name: null,
    equipment_quantity: 1,
    equipment_description: null,

    // rental
    rental_price: null,
    rental_days: null,

    // sell
    sell_price: null,

    // other
    other_price: null,
    other_description: null,
  };
};

export const manifest = {
  id: "EQUIPMENT",
  name: "Equipamento",
  icon: "mdi-cog",
  description: "Negociação de equipamentos",
  defaultData: defaultData,
};

export default {
  name: "EquipmentEditor",
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      modalTypes: [
        { id: "rental", name: "Aluguel" },
        { id: "sell", name: "Venda" },
        { id: "loan", name: "Emprestimo" },
      ],
    };
  },

  methods: {
    setKey(key, value, parse = false) {
      this.data = {
        ...this.data,
        [key]: !value ? value : parse ? parse(value) : value,
      };
    },
    getTotal() {
      let value = 0;
      const equipmentQuantity = this.data.equipment_quantity || 0;

      if (this.data.type.includes("rental")) {
        const rentalPrice = this.data.rental_price || 0;
        const rentalDays = this.data.rental_days || 0;
        value += rentalPrice * rentalDays * equipmentQuantity;
      }

      if (this.data.type.includes("sell")) {
        const sellPrice = this.data.sell_price || 0;
        value += sellPrice * equipmentQuantity;
      }

      return value;
    },
  },
  watch: {
    valid(value) {
      this.$emit("update:valid", value);
    },
    data: {
      handler(value) {
        this.$emit("update:amount", this.getTotal());
      },
      deep: true,
    },
  },
  computed: {
    data: {
      get() {
        return this.value || defaultData();
      },
      set(value) {
        this.$emit("update", value);
      },
    },
  },
  mounted() {
    this.$emit("update:valid", this.valid);
  },
};
</script>
